const formatCurrency = (currency: string, value: number): string => {
  const trimmedCurrency = currency.trim();

  // Note: This should not longer be expected, but we are adding this just in case old "--"/"-" values are left behind
  if (trimmedCurrency === '--' || trimmedCurrency === '-') {
    return value?.toString();
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: trimmedCurrency,
    currencyDisplay: 'symbol',
  });

  return formatter.format(value);
};

export default formatCurrency;
